var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Color",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m15.3 12.3c-.02 0-.041-.001-.061-.002l-4.342-.355c-.254-.021-.48-.169-.6-.394s-.118-.495.005-.718l5.792-10.444c.132-.239.384-.387.656-.387h4.5c.265 0 .511.14.646.369.135.228.139.511.011.743l-5.95 10.8c-.133.24-.385.388-.657.388z",
    fill: "#d32f2f"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13.81 10.466-5.913-10.095c-.134-.23-.381-.371-.647-.371h-4.5c-.265 0-.511.14-.646.369-.135.228-.139.51-.011.743l5.95 10.8c.134.242.387.388.657.388.039 0 .078-.003.117-.009l4.462-.705c.245-.039.455-.196.561-.42.107-.224.095-.486-.03-.7z",
    fill: "#f44336"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12 24c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z",
    fill: "#ffc107"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14.009 21c-.125 0-.25-.031-.363-.094l-1.646-.909-1.646.91c-.251.139-.561.123-.795-.043-.235-.166-.354-.451-.309-.734l.323-1.978-1.361-1.395c-.196-.201-.264-.496-.174-.762.089-.267.319-.46.598-.503l1.851-.283.834-1.777c.246-.527 1.111-.527 1.357 0l.834 1.777 1.851.283c.278.042.509.236.598.503.09.267.022.561-.174.762l-1.361 1.395.323 1.978c.046.283-.073.568-.309.734-.128.09-.28.136-.431.136z",
    fill: "#ff8f00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.641cfd6fb972b0014385596eaf1685f0.svg";
export { ForwardRef as ReactComponent };